<template>
  <b-row>
    <b-col md="12" lg="12" sm="12">
      <div class="contenedor">
        <b-card class="contenedor">
          <div slot="header">
            <strong>
              <center style="font-size:12pt;">Medidas</center>
            </strong>
          </div>

          <b-row>
            <b-col>
              <center><el-checkbox v-model="VisualEmpresa.regla" label="Regla" border ></el-checkbox></center>
            </b-col>
            <b-col>
              <center><el-checkbox v-model="VisualEmpresa.fecha_fab" label="Fabricante-FechaFDS" border ></el-checkbox></center>
            </b-col>
          </b-row>

          <table class="table" style="font-size:9pt;">
            <tr>
              <th>Medida</th>
              <th>Frases H</th>
              <th>Frases P</th>
              <th>Sin Cab</th>
              <th>Cab</th>
            </tr>
            <tr>
              <th style="width:100px;font-size:8pt;">5x6,5x7cm (Baker 7x5cm)</th>
              <th>
                <b-form-select
                  style="width:50px;"
                  v-model="Medidas.medidah4x6"
                  :options="Medidas.medidah"
                  
                ></b-form-select>
              </th>
              <th>
                <b-form-select
                  style="width:50px;"
                  v-model="Medidas.medidap4x6"
                  :options="Medidas.medidap"
                  
                ></b-form-select>
              </th>
              <th>
                <i @click="generarEtiquetas('A')" class="fa fa-file-pdf-o fa-3x"></i>
              </th>
              <th>
                <i @click="generarEtiquetas('B')" class="fa fa-file-pdf-o fa-3x"></i>
              </th>
            </tr>
            <tr>
              <th style="width:100px;font-size:8pt;">7x10,7x12cm</th>
              <th>
                <b-form-select
                  style="width:50px;"
                  v-model="Medidas.medidah7x10"
                  :options="Medidas.medidah"
                  
                ></b-form-select>
              </th>
              <th>
                <b-form-select
                  style="width:50px;"
                  v-model="Medidas.medidap7x10"
                  :options="Medidas.medidap"
                  
                ></b-form-select>
              </th>
              <th>
                <i @click="generarEtiquetas('C')" class="fa fa-file-pdf-o fa-3x"></i>
              </th>
              <th>
                <i @click="generarEtiquetas('D')" class="fa fa-file-pdf-o fa-3x"></i>
              </th>
            </tr>
            <tr>
              <th style="width:100px;font-size:8pt;">18x10,18x12cm</th>
              <th>
                <b-form-select
                  style="width:50px;"
                  v-model="Medidas.medidah18x10"
                  :options="Medidas.medidah"
                  
                ></b-form-select>
              </th>
              <th>
                <b-form-select
                  style="width:50px;"
                  v-model="Medidas.medidap18x10"
                  :options="Medidas.medidap"
                  
                ></b-form-select>
              </th>
              <th>
                <i @click="generarEtiquetas('E')" class="fa fa-file-pdf-o fa-3x"></i>
              </th>
              <th>
                <i @click="generarEtiquetas('F')" class="fa fa-file-pdf-o fa-3x"></i>
              </th>
            </tr>
            <tr>
              <th style="width:100px;font-size:8pt;">21x18,22x18cm (Baker 29x21cm)</th>
              <th>
                <b-form-select
                  style="width:50px;"
                  v-model="Medidas.medidah21x18"
                  :options="Medidas.medidah"
                  
                ></b-form-select>
              </th>
              <th>
                <b-form-select
                  style="width:50px;"
                  v-model="Medidas.medidap21x18"
                  :options="Medidas.medidap"
                  
                ></b-form-select>
              </th>
              <th>
                <i @click="generarEtiquetas('G')" class="fa fa-file-pdf-o fa-3x"></i>
              </th>
              <th>
                <i @click="generarEtiquetas('H')" class="fa fa-file-pdf-o fa-3x"></i>
              </th>
            </tr>
          </table>
        </b-card>
      </div>
    </b-col>   
  </b-row>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Medidas-et-sga",
   data() {
    return {
      opt369: [3, 6, 9],
      opt24: [2, 4],
      cantidad1: 3,
      cantidad2: 3,
      cantidad3: 2,
      cantidad4: 2
    };
  },
  computed: {
    disabledInputs() {
      return this.selectedProductEt.finalizado == 0 ? false : true
    },
    ...mapState('etiquetas_et', [
      'pdfet',
      'VisualEmpresa'
    ]),
    ...mapState('sga_et',[
        'filtro',
        'Medidas'
    ]),
    ...mapState('productos_et',[
        'accion',
        'id_empresa',
        'ordenes',
        'empresas',
        'filtroEt',
        'selectedProductEt'
    ])
  },
  methods: {
    ...mapActions('etiquetas_et',[
      'generarEtiqueta'
    ]),
    
    async generarEtiquetas( tipo, cantidad = 0) {
      if( this.filtroEt.empresa != '' ){
        this.pdfet.empresa = this.filtroEt.empresa;
      }else{
        this.pdfet.empresa = this.idEmpresa;
      }

      this.pdfet.idioma = this.selectedProductEt.idioma
      this.pdfet.version = 6
      this.pdfet.regla = this.VisualEmpresa.regla
      this.pdfet.fabfecha = this.VisualEmpresa.fecha_fab
      this.pdfet.rol = 1
      this.pdfet.tipoproducto = 'productoEt'
      this.pdfet.cabecera = 0
      this.pdfet.tipoEtiqueta = tipo
      this.pdfet.cantidad = cantidad
      
      await this.generarEtiqueta()
    },
  }
};
</script>